module.exports = __webpack_public_path__ + "img/logooo.313d1dd2.png";